import * as React from 'react';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import ErrorsCore from '../AfrCore/ErrorsCore';

const ErrorsA = (props: any) => {

    return (
        <React.Fragment>
            <ErrorsCore userRole="ENTITY_USER" taxType={TaxonomyTypeEnum.AFR} reportName="AFR" />
        </React.Fragment>
    );
}

export default ErrorsA;